import './Theme.Page.Modal.scss';
export default 'ThemePageModal';
